document.addEventListener('DOMContentLoaded', function() {
	const filterBtn = document.querySelector('.req-list-filter');
	const mainPopup = document.querySelector('.req-main-popup');
	const subPopup = document.querySelector('.req-sub-popup');
	const closeMainPopup = document.querySelector('.js-close-popup');
	const closeSubPopup = document.querySelector('.js-close-sub-popup');
	const groupOnCheckbox = document.getElementById('group-on');
	const groupCategory = document.getElementById('group-category');
	const selectGroupBtn = document.getElementById('select-group-values');
	const selectedGroupValuesBox = document.getElementById('selected-group-values');
	const groupValuesList = document.getElementById('group-values-list');
	const applyBtn = document.getElementById('apply-filter');
	const resetBtn = document.getElementById('reset-filter');

	const currentFilter = {
		showTasks: false,
		dateEnd: '',
		group: {
			enabled: false,
			field: 'district',
			values: []
		}
	};

	const urlParams = new URLSearchParams(window.location.search);

	currentFilter.showTasks = urlParams.has('show-tasks');
	currentFilter.dateEnd = urlParams.get('date-end') || '';
	currentFilter.group.enabled = urlParams.has('group-on');
	currentFilter.group.field = urlParams.get('grouping') || 'district';
	currentFilter.group.values = urlParams.getAll('group-values[]') || [];

	// Функция для обновления чипсов
	document.querySelectorAll('.filter-chip-remove').forEach(chip => {
		chip.addEventListener('click', function () {
			const paramToRemove = this.dataset.param;
			const specificValue = this.dataset.value;

			switch(paramToRemove) {
				case 'show-tasks':
					urlParams.delete('show-tasks');
					break;

				case 'date-end':
					urlParams.delete('date-end');
					break;

				case 'group-on':
					urlParams.delete('group-on');
					urlParams.delete('grouping');
					urlParams.delete('group-values[]');
					break;

				case 'group-values[]':
					// Удаляем только конкретное значение из group-values[]
					if (specificValue) {
						const values = urlParams.getAll('group-values[]').filter(v => v !== specificValue);
						urlParams.delete('group-values[]');
						values.forEach(v => urlParams.append('group-values[]', v));
					}
					break;
			}

			window.location.search = urlParams.toString();
		});
	});

	if (!filterBtn) return;

	const groupRadioButtons = groupCategory.querySelectorAll('input[type="radio"]');
	const searchInput = document.getElementById('search-input');
	function renderSelectedValues() {
		selectedGroupValuesBox.textContent = currentFilter.group.values.join(', ') || '(не выбрано)';
	}

	function loadGroupValues(field) {
		return BX.ajax.runComponentAction('main:repair', 'getGroupFields', {
			mode: 'ajax',
			data: { groupField: field }
		}).then(res => res.data);
	}

	function handleSearch() {
		const searchTerm = this.value.toLowerCase();

		document.querySelectorAll('.group-value-item').forEach(row => {
			const checkbox = row.querySelector('.group-cb');
			if (!checkbox) return;

			const textToSearch = checkbox.value.toLowerCase();
			row.style.display = textToSearch.includes(searchTerm) ? '' : 'none';
		});
	}

	function openSubPopup(values = []) {
		groupValuesList.innerHTML = '';
		values.forEach(val => {
			const id = `group-val-${val.ID}`;
			const isChecked = currentFilter.group.values.includes(val.VALUE);
			groupValuesList.insertAdjacentHTML('beforeend', `
				<div class="group-value-item">
					<label>
						<input type="checkbox" class="group-cb" name="group-values" value="${val.VALUE}" id="${id}" ${isChecked ? 'checked' : ''}>
						${val.VALUE}
					</label>
				</div>
			`);
		});

		subPopup.style.display = 'block';
		mainPopup.style.display = 'none';
	}

	//поиск в дполнительном попапе
	searchInput.addEventListener('input', handleSearch);

	// Открытие главного попапа
	filterBtn?.addEventListener('click', () => {
		mainPopup.style.display = 'block';
	});

	closeMainPopup?.addEventListener('click', () => {
		mainPopup.style.display = 'none';
	});

	closeSubPopup?.addEventListener('click', () => {
		subPopup.style.display = 'none';
		mainPopup.style.display = 'block';
	});

	// Обработка включения группировки
	groupOnCheckbox?.addEventListener('change', (e) => {
		const enabled = e.target.checked;
		currentFilter.group.enabled = enabled;
		groupCategory.style.display = enabled ? 'block' : 'none';

		groupRadioButtons.forEach(rb => rb.disabled = !enabled);
	});

	// Изменение типа группировки
	groupCategory?.addEventListener('change', (e) => {
		if (e.target.name === 'grouping') {
			currentFilter.group.field = e.target.value;
		}
	});

	// Открытие под-попапа выбора значений
	selectGroupBtn?.addEventListener('click', async () => {
		const field = currentFilter.group.field;
		const values = await loadGroupValues(field);
		openSubPopup(values);
	});

	// Подтверждение выбора значений
	document.getElementById('group-values-form')?.addEventListener('submit', (e) => {
		e.preventDefault();

		const checked = [...groupValuesList.querySelectorAll('input:checked')];
		currentFilter.group.values = checked.map(i => i.value);

		subPopup.style.display = 'none';
		mainPopup.style.display = 'block';
		renderSelectedValues();
	});

	// Применение фильтра
	applyBtn?.addEventListener('click', () => {
		const params = new URLSearchParams();

		currentFilter.showTasks = document.getElementById('show-tasks').checked;
		currentFilter.dateEnd = document.getElementById('date-end').value;

		if (currentFilter.showTasks) params.set('show-tasks', '1');
		if (currentFilter.dateEnd) params.set('date-end', currentFilter.dateEnd);

		if (currentFilter.group.enabled) {
			params.set('group-on', '1');
			params.set('grouping', currentFilter.group.field);
			currentFilter.group.values.forEach(v => params.append('group-values[]', v));
		}

		window.location.search = params.toString();
	});

	// Сброс фильтра
	resetBtn?.addEventListener('click', () => {
		window.location.href = window.location.pathname;
	});
});